import {
    createAppointment,
    createAppointmentConfirmation,
    deleteAppointmentById,
    readAppointmentById,
    readAppointments,
    replaceAppointment,
} from 'api/appointment';
import {
    getFilteredParamsToRequest,
    getTransformedAttachmentsToRequest,
    getTransformedGoogleAddressFromResponse,
    getTransformedGoogleAddressToRequest,
} from './utils';
import { AppointmentFormData } from 'types/appointment';
import { CreateAppointmentConfirmationRequest, GetAppointmentsRequest } from 'api/appointment/types';

export const createUserAppointment = ({ address, attachments, ...data }: AppointmentFormData) => {
    const requestData = {
        ...data,
        ...getTransformedGoogleAddressToRequest(address),
        attachments: getTransformedAttachmentsToRequest(attachments),
    };
    return createAppointment(requestData).then((res) => res.data);
};

export const updateUserAppointment = (
    appointmentId: string,
    { address, attachments, ...data }: AppointmentFormData,
) => {
    const requestData = {
        ...data,
        ...getTransformedGoogleAddressToRequest(address),
        attachments: getTransformedAttachmentsToRequest(attachments),
    };
    return replaceAppointment(appointmentId, requestData).then((res) => res.data);
};

export const getAppointments = (params: GetAppointmentsRequest) => {
    return readAppointments(getFilteredParamsToRequest(params)).then((res) => res.data);
};

export const updateAppointmentConfirmation = (appointmentId: string, params: CreateAppointmentConfirmationRequest) => {
    return createAppointmentConfirmation(appointmentId, params).then((res) => res.data);
};

export const getAppointmentById = (id: string) => {
    return readAppointmentById({ id }).then(({ data }) => {
        const {
            title,
            description,
            scheduledDateTime,
            email,
            firstName,
            middleName,
            lastName,
            address,
            placeId,
            houseDescription,
            phoneNumber,
            attachments,
            status,
        } = data;
        return {
            data: {
                title,
                description,
                scheduledDateTime,
                email,
                firstName,
                middleName,
                lastName,
                address: getTransformedGoogleAddressFromResponse(address, placeId),
                houseDescription,
                phoneNumber,
                attachments,
            },
            status,
        };
    });
};

export const getAppointmentDetails = (id: string) => readAppointmentById({ id }).then(({ data }) => data);

export const deleteAppointment = (id: string) => {
    return deleteAppointmentById({ id }).then((res) => res.data);
};
